import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { Api } from '../axiosApi';
export type TTipoContaFinanceira = 'banco' | 'caixa' | 'cofre' | 'recebiveis';

export interface IListagemConta {
  idconta: string;
  nomebanco?: string;
  agencia?: string;
  numeroconta?: string;
  status: boolean;
  titular: string;
  banco?: string;
  tipo?: TTipoContaFinanceira;
}
type TComTotalCount = {
    data: IListagemConta[];
    totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const getAllList = async (filter = '', id = '', tipo?: string, limit = 5): Promise<TComTotalCount | Error> => {
  try {
    let urlRelativa: string;
    if (id === '') {
      const params = new URLSearchParams({ limit: String(limit), filter });
      if (tipo) params.set('tipo', tipo);
      urlRelativa = `/contabancarialist?${params.toString()}`;
    } else {
      urlRelativa = `/contabancarialist/${id}`;
    }
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const ContaBancariaService = {
  getAllList,
};